import { Box, Button, Grid, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import FavoriteButton from '../../../../shared/components/buttons/FavoriteButton'
import Visibility from '../../../../shared/components/frontoffice/Visibility'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'

const StyledImg = styled('img')(() => ({
  borderRadius: '8px 8px 8px 8px',
  maxWidth: '100%',
  cursor: 'pointer'
}))

const OfferBlock = ({ offer, type }: { offer: any; type: any }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleFavoriteClick = (offer_id: number) => (state: boolean) => {
    if (state) {
      dispatch(setFavorite({ id: offer_id, state, type: 'offer' }))
    } else {
      dispatch(unsetFavorite({ id: offer_id, state, type: 'offer' }))
    }
  }

  return (
    <>
      {type === 0 ? (
        <Box position="relative" overflow="hidden" sx={{ height: { xs: 241, sm: 376 }, width: '100%', padding: { xs: 0 } }}>
          <Tooltip title={offer.title}>
            <Button fullWidth sx={{ height: '100%', padding: 0, borderRadius: 2 }}>
              <Box
                onClick={() => {
                  navigate(`/ofertas/${offer.id}`)
                }}
                sx={{
                  backgroundSize: 'cover !important',
                  backgroundRepeat: 'no-repeat !important',
                  backgroundPosition: 'center center !important',
                  width: { xs: '100%', sm: '97%' },
                  height: { xs: 241, sm: 360 },
                  position: 'absolute',
                  borderRadius: 2,
                  background: `${encodeURI(`url(${import.meta.env.VITE_AWS_URL}/offers/${offer.image})`)}`
                }}
              />
            </Button>
          </Tooltip>
        </Box>
      ) : (
        <>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Tooltip title={offer.title}>
                <Button
                  sx={{ padding: 0, borderRadius: 2 }}
                  onClick={() => {
                    navigate(`/ofertas/${offer.id}`)
                  }}
                >
                  <StyledImg src={`${encodeURI(`${import.meta.env.VITE_AWS_URL}/offers/${offer.image}`)}`} alt={offer.title} />
                </Button>
              </Tooltip>
              <Box display="flex" justifyContent="space-between" alignContent="center" pt={1}>
                <Box sx={{ '& button': { marginBottom: '-7px', position: 'relative', bottom: 6 } }}>
                  <FavoriteButton handleClick={handleFavoriteClick(offer.id)} favoriteState={Boolean(offer.favoriteId)} />
                  <ShareIcon
                    visibility={offer.visibility}
                    title={offer.title}
                    description={offer.description}
                    link={`${window.location.origin}/ofertas/${offer.id}${window.location.search}`}
                    multimedia={offer.image_url}
                    type="offer"
                  />
                </Box>
                <Visibility type={offer.visibility} />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  )
}

export default OfferBlock
